import { Input } from "@/components/ui/input";
import { COUNTRIES } from "@/lib/countries";

interface Props {
  dialCode: string;
  number: string;
  onDialCode: (v: string) => void;
  onNumber: (v: string) => void;
}

/** Country-code dropdown + local number. The parent combines them into E.164. */
export function PhoneInput({ dialCode, number, onDialCode, onNumber }: Props) {
  return (
    <div className="flex gap-2">
      <select
        value={dialCode}
        onChange={(e) => onDialCode(e.target.value)}
        className="w-28 shrink-0 cursor-pointer rounded-md border border-border bg-card px-2 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring"
      >
        {COUNTRIES.map((c) => (
          <option key={c.iso + c.dial} value={c.dial}>
            {c.flag} {c.dial}
          </option>
        ))}
      </select>
      <Input
        value={number}
        onChange={(e) => onNumber(e.target.value)}
        placeholder="712 345 678"
        inputMode="tel"
        className="flex-1"
      />
    </div>
  );
}

/** Combine a dial code + raw number into an E.164 string, or undefined if blank. */
export function toE164(dialCode: string, number: string): string | undefined {
  const digits = number.replace(/\D/g, "");
  return digits ? `${dialCode}${digits}` : undefined;
}
